/**
 * Created by dreamc_t on 2017/4/7.
 */
require('./eventData.scss');
var tmpl = require('./eventData.ejs');


// 线上http://api.livesports.ifeng.com // 本地接口http://10.21.7.47:8099
var apiDomain = '//api.livesports.ifeng.com';
var requestUrl = apiDomain + '/livesports/events/eventslist?'; // 事件数据
var eventlistUrl = apiDomain + '/livesports/events/eventsstatus?'; // 所有事件状态

var sportsEventData = function (info) {
    this.matchId = info.matchId;
    this.container = info.container;
    this.requestData();
    this.initEvent();
};
Array.prototype.removeRepeat = function () {
    var arr = this,
        i,
        obj = {},
        result = [];
    for (i = 0; i < arr.length; i++) {
        if (!obj[arr[i].status]) { //如果能查找到，证明数组元素重复了
            obj[arr[i].status] = 1;
            result.push(arr[i]);
        }
    }
    return result;
}
sportsEventData.prototype.formatData = function (data) {
    var _this = this;
    let list = data.eventsList || [];
    // console.log('formdata--', this.eventlist);

    let hasData = Object.keys(list).length || 0;
    Object.keys(list).forEach(function (key) {
        let timeArr = list[key] || []; // 同时间的事件列表
        // 处理前5个状态的描述
        timeArr.map(function (item) {
            if (item.status && parseInt(item.status) <= 5) {
                let target = _this.eventlist.filter(function (event) {
                    return event.value == item.status;
                });
                item.desc = target && target.length ? target[0].label : '';
            }
            return item;
        });

        // 排序---012345为特殊状态，移到相同时间的最前边
        // 小于5的放在前边，按大小排序---大于5的放后边，不排序
        let special = timeArr.filter(function (time) {
            return parseInt(time.status) <= 5;
        }).removeRepeat();// 去重
        special.length > 1 && special.sort((v1, v2) => {
            return parseInt(v1.status) - parseInt(v2.status);
        }); // 小于5的排序

        let left = timeArr.filter(function (item) {
            return item.team && parseInt(item.team) == 0; // 主队
        });
        let right = timeArr.filter(function (item) {
            return item.team && parseInt(item.team) == 1; // 主队
        });
        list[key] = {
            time: key,
            md: special || [],
            left: left || [],
            right: right || []
        };
        // console.log('list--', key, list);
    })
    return {
        list: list,
        hasData: hasData
    };
}
sportsEventData.prototype.requestEventList = function () {
    var _this = this;
    $.ajax({
        url: requestUrl,
        type: 'get',
        data: {
            mid: this.matchId,
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp',
        success: function (data) {
            // console.log('sportsEventData---requestData-success-', data);
            if (data && data.code === 0) {
                let result = _this.formatData(data.data || {});
                _this.el = $(tmpl({ data: result }));
                _this.renderTo(_this.container);
            } else {
                alert(data.message)
            }
        },
        error: function (e) {
            // console.log('sportsEventData---requestData-error-', data);
            alert('获取体育历史数据接口失败');
        }
    });
}
sportsEventData.prototype.requestData = function () {
    var _this = this;
    // 先获取事件状态---再获取事件历史数据---格式化--渲染
    $.ajax({
        url: eventlistUrl,
        type: 'get',
        data: {
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp',
        success: function (data) {
            // console.log('sportsEventData---requestData-success-', data);
            if (data && data.code === 0) {
                _this.eventlist = data.data;
                _this.requestEventList(); // 获取历史数据
            } else {
                alert(data.message)
            }
        },
        error: function (e) {
            // console.log('sportsEventData---requestData-error-', data);
            alert('获取事件状态数据接口失败');
        }
    });
};
sportsEventData.prototype.renderTo = function (parentNode) {
    if ($(this.el)[0]) {

        if (document.getElementsByClassName('sports-event').length) {
            // 移除之前的
            parentNode.removeChild(document.getElementsByClassName('sports-event')[0]);
        }
        parentNode.insertBefore($(this.el)[0], parentNode.firstChild);
    }
};
sportsEventData.prototype.initEvent = function () {
    var _this = this;
    const $eventSetting = {
        url: requestUrl,
        type: 'get',
        data: {
            mid: _this.matchId,
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp',
        success: function (data) {
            if (data && data.code === 0) {
                let result = _this.formatData(data.data);
                _this.el = $(tmpl({ data: result }));
                _this.renderTo(_this.container);
            } else {
                alert(data.message)
            }
        },
        error: function (e) {
            alert('获取事件历史数据接口报错')
        },
        complete: function () {
            // 轮询请求
            clearTimeout(_this.timerForEvent);
            _this.timerForEvent = setTimeout(function () {
                $.ajax($eventSetting);
            }, 240000); // 4min
        }
    }
    clearTimeout(_this.timerForEvent);
    _this.timerForEvent = setTimeout(function () {
        $.ajax($eventSetting);
    }, 240000); // 4min
};
module.exports = sportsEventData;




// WEBPACK FOOTER //
// ./app/modules/eventData/index.js